import React, { Fragment, useEffect, useState } from 'react'
import { Box, Chip, Grid, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Tooltip, Typography } from '@mui/material'
import Colors from '../../../Assets/Styles/Colors'
import { Edit, KeyboardArrowLeft, KeyboardArrowRight, RemoveRedEye } from '@mui/icons-material'
import BreadCrumbs from '../../../Components/BreadCrumbs/BreadCrumbs'
import { useNavigate } from 'react-router-dom'
import { CircleLoading } from '../../../Components/Loaders/CircleLoading'
import AdleaksServices from '../../../Api/AdLeak/AdleaksServices'
import moment from 'moment'
import { useTheme } from '@emotion/react';
import ConfirmationDialog from '../../../Components/Dialogs/ConfirmationDialog'
import useAuth from "../../../hooks/useAuth";

const tableHead = [
  "Title",
  "Category",
  "Created At",
  "Status",
  "Action"
];

function TablePaginationActions(props) {
  const theme = useTheme;

  const { count, page, rowsPerPage, onPageChange } = props;

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, []);

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
    </Box>
  );
}

function UserAdLeakListing() {
  const [loading, setLoading] = useState(false);
  const [allAdleaks, setAllAdleaks] = useState([]);
  const [totalCount, setTotalCount] = useState("");
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [open, setOpen] = useState(false);
  const [id, setId] = useState("");
  const navigate = useNavigate();
  const { isAdmin } = useAuth();

  const getAllAdLeaks = async (catId, searchKey, newPage, rows) => {
    setLoading(true);
    try {
      const result = await AdleaksServices.getAllAdLeaks(
        catId ? catId : null,
        searchKey ? searchKey : "",
        newPage ? newPage : 1,
        rows ? rows : limit,
        "adleak",
        false
      );
      console.log("🚀 ~ getAllAdLeaks ~ result:", result)
      const filtered = result?.data?.blogs?.filter((blog) => blog?.user_id != isAdmin);
      setAllAdleaks(filtered);
      setTotalCount(filtered?.length);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    getAllAdLeaks("", "", newPage + 1, limit);
  };

  const handleChangeRowsPerPage = (event) => {
    setLimit(Math.floor(event.target.value));
    setPage(0);
    getAllAdLeaks("", "", page, event.target.value);
  };

  const approveBlog = async () => {
    const obj = {
      isApproved: true,
      // status: true,
    }
    try {
      const result = await AdleaksServices.approveBlog(id, obj);
      console.log(result);
    } catch (error) {
      console.log(error)
    }
    finally {
      getAllAdLeaks();
    }
  }

  const disApproveBlog = async () => {
    const obj = {
      isApproved: false,
      status: false,
    }
    try {
      const result = await AdleaksServices.approveBlog(id, obj);
      console.log(result);
    } catch (error) {
      console.log(error)
    }
    finally {
      getAllAdLeaks();
    }
  }

  useEffect(() => {
    getAllAdLeaks("", "", page, limit);
  }, [])

  return (
    <Fragment>
      <ConfirmationDialog
        open={open}
        onClose={() => setOpen(false)}
        action={approveBlog}
        title={"Approve Blog"}
        btn={"Approve"}
        secBtn={"Disapprove"}
        secAction={disApproveBlog}
      />
      <Box>
        <Grid
          container
          alignItems="center"
          justifyContent="space-between"
          sx={{
            background: Colors.primaryGradient,
            p: 2,
            borderRadius: "12px",
          }}
        >
          <Grid item xs={6}>
            <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <IconButton onClick={() => navigate(-1)}>
                <KeyboardArrowLeft sx={{ color: Colors.white }} />
              </IconButton>
              <Typography variant="body1" fontWeight="bold" sx={{ color: Colors.white }}>
                Users AdLeak List
              </Typography>
            </Box>
          </Grid>
          <Grid
            item
            xs={6}
            sx={{ display: "flex", justifyContent: "flex-end" }}
          >
            <BreadCrumbs currentPage={["Users AdLeak List"]} />
          </Grid>
        </Grid>
        <Box>
          {loading ? (
            <CircleLoading />
          ) : (
            <Fragment>
              <TableContainer
                component={Paper}
                sx={{
                  // width: "calc(100vw - 320px)",
                  "&::-webkit-scrollbar": {
                    bgcolor: Colors.white,
                    height: "8px",
                    borderRadius: "10px",
                    cursor: "pointer",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    bgcolor: Colors.primary,
                    borderRadius: "10px",
                    cursor: "pointer",
                  },
                  "&.MuiPaper-root": {
                    borderRadius: "12px",
                    mt: 2,
                    boxShadow: 0,
                  },
                }}
              >
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                  <TableHead>
                    <TableRow sx={{ bgcolor: Colors.lightGray }}>
                      {tableHead.map((item, index) => (
                        // <TableCell
                        //   key={index}
                        //   colSpan={item == "Posted By" ? 2 : 1}
                        //   rowSpan={item == "Posted By" ? 2 : 1}
                        // >
                        //   <Typography
                        //     sx={{
                        //       fontWeight: "bold",
                        //       textAlign: item == "Posted By" ? "center" : item == "Actions" && "end",
                        //       width: "130px"
                        //     }}
                        //   >
                        //     {item}
                        //   </Typography>
                        //   {item == 'Posted By' && (
                        //     <Typography sx={{ width: "100%", display: "flex" }}>
                        //       <Typography sx={{ width: "50%" }}>Name</Typography>
                        //       <Typography sx={{ width: "50%" }}>Role</Typography>
                        //     </Typography>
                        //   )}
                        // </TableCell>
                        <TableCell key={index}>
                          <Typography
                            sx={{
                              fontWeight: "bold",
                              // textAlign: item == "Posted By" ? "center" : item == "Actions" && "end",
                              width: "130px"
                            }}
                          >
                            {item}
                          </Typography>
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {allAdleaks.map((row, index) => (
                      <TableRow key={index}>
                        <TableCell>
                          <Typography
                            variant={"body2"}
                            sx={{
                              textWrap: "nowrap",
                              width: "140px",
                              textOverflow: "ellipsis",
                              overflow: "hidden"
                            }}
                          >
                            {row?.title}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          {row?.category?.name}
                        </TableCell>
                        <TableCell>
                          {moment(row?.createdAt).format("DD-MM-YYYY")}
                        </TableCell>
                        <TableCell>
                          <Chip
                            label={row?.isApproved == null
                              ? "Pending" : row?.isApproved == true
                                ? "Active"
                                : "Disapproved"}
                            sx={{
                              bgcolor:
                                row?.isApproved == null
                                  ? Colors.warning : row?.isApproved == true
                                    ? Colors.success + 26
                                    : Colors.gunMetal,
                              color:
                                row?.isApproved == null
                                  ? Colors.white : row?.isApproved == true
                                    ? Colors.success
                                    : Colors.white,
                              height: 26,
                              textTransform: 'capitalize',
                            }}
                          />
                        </TableCell>
                        <TableCell>
                          <Box>
                            <Tooltip title="Status">
                              <IconButton
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setOpen(true);
                                  setId(row?._id);
                                }}
                              >
                                <Edit sx={{ color: Colors.success }} />
                              </IconButton>
                            </Tooltip>
                            <Tooltip title="View">
                              <IconButton
                                onClick={(e) => {
                                  e.stopPropagation();
                                  navigate(`/adleak-edit/${row?._id}`, { state: row })
                                }}
                              >
                                <RemoveRedEye sx={{ color: Colors.primary }} />
                              </IconButton>
                            </Tooltip>
                          </Box>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
              <Table sx={{ marginTop: "12px" }}>
                <TablePagination
                  sx={{
                    borderBottom: "none",
                    bgcolor: Colors.white,
                    borderRadius: "12px",
                  }}
                  rowsPerPageOptions={[10, 20, 30]}
                  colSpan={12}
                  count={+totalCount}
                  rowsPerPage={limit}
                  page={page}
                  SelectProps={{
                    inputProps: {
                      "aria-label": "rows per page",
                    },
                    native: true,
                  }}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  ActionsComponent={TablePaginationActions}
                />
              </Table>
            </Fragment>
          )}
        </Box>
      </Box>
    </Fragment>
  )
}

export default UserAdLeakListing